import React from 'react';

var LobbyRoomWinner = function (_a) {
    var playerIdText = _a.playerIdText, betAmountText = _a.betAmountText, winAmountText = _a.winAmountText, imgSrc = _a.imgSrc;
    return (React.createElement("div", { className: 'pgc-lobby-room-winner' },
        imgSrc && React.createElement("img", { src: imgSrc, alt: '', className: 'pgc-lobby-room-winner-img' }),
        React.createElement("p", { className: 'pgc-winner-r-text' }, playerIdText),
        React.createElement("p", { className: 'pgc-winner-r-text' }, betAmountText),
        React.createElement("p", { className: 'pgc-winner-r-text win' }, winAmountText)));
};

export { LobbyRoomWinner };
